import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, {
    Column,
    HeaderFilter,
    Lookup
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import apiUrls from '../../common/api/api-urls';
import { trans } from '../../common/utils';
import { languages } from '../../configs/i18n';
import { setUnactiveRows } from '../../common/utils';
import {
    LanguageTemplate,
    dataGridDefaultSettings,
} from '../../components';

const IncomePercentPage = ({
    store: {
        languages: { table },
    },
}) => {

    return (
        <>
            <DataGrid
                {...dataGridDefaultSettings({
                    settingStorageName: 'BMA_grid_info_incomePercent_USERID',
                    url: apiUrls.info.incomePercent,
                    key: 'id',
                    language: languages.languageId[table],
                    editorPreparingArray: 'serviceProviderId',
                    languagePicker: false,
                    toolbarCenter: `${useLocation().pathname}`,
                    editing: {
                        allowAdding: true,
                        allowUpdating: true,
                        allowDeleting: true,
                    },
                    columnFixing: { enabled: false },
                })}
                onRowPrepared={setUnactiveRows}
            >
                <HeaderFilter visible={true} allowSearch={true} />

                <Column
                    dataField={'id'}
                    caption={trans('ID')}
                    dataType={'number'}
                    width={90}
                    sortOrder={'asc'}
                    allowFixing={false}
                    allowHiding={false}
                    showInColumnChooser={false}
                    allowSearch={false}
                    allowEditing={false}
                />

                <Column
                    dataField={'serviceProviderId'}
                    caption={trans('Сервис провайдер')}
                    dataType={'number'}
                    width={120}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                >
                    <Lookup
                        dataSource={createStore({
                            key: 'key',
                            loadUrl: apiUrls.lookup.serviceProvider,
                            onBeforeSend: (method, ajaxOptions) => {
                                //ajaxOptions.data.languageid = 1;
                                ajaxOptions.xhrFields = {
                                    withCredentials: true,
                                };
                            },
                        })}
                        displayExpr={'value'}
                        valueExpr={'key'}
                    />
                </Column>

                <Column
                    dataField={'serviceId'}
                    caption={trans('Сервис')}
                    dataType={'number'}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                >
                    <Lookup
                        dataSource={createStore({
                            key: 'key',
                            loadUrl: apiUrls.lookup.service,
                            onBeforeSend: (method, ajaxOptions) => {
                                //ajaxOptions.data.languageid = 1;
                                ajaxOptions.xhrFields = {
                                    withCredentials: true,
                                };
                            },
                        })}
                        displayExpr={'value'}
                        valueExpr={'key'}
                    />
                </Column>
                <Column
                    dataField={'amountFrom'}
                    caption={trans('Сумма от')}
                    dataType={'number'}
                    width={255}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'amountTo'}
                    caption={trans('Сумма до')}
                    dataType={'number'}
                    allowFixing={false}
                    width={255}
                />
                <Column
                    dataField={'percentToDisplay'}
                    caption={trans('Процент')}
                    dataType={'number'}
                    width={222}
                    allowFixing={false}
                />
                <Column
                    dataField={'idt'}
                    caption={trans('Дата вставки')}
                    dataType={'datetime'}
                    format={'dd/MM/yyyy HH:mm:ss'}
                    width={280}
                    visible={false}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />
                <Column
                    caption={''}
                    width={20}
                    visible={true}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    allowHiding={false}
                    allowReordering={false}
                />
                <Template
                    name={'languageBar'}
                    render={() => <LanguageTemplate />}
                />
            </DataGrid>
        </>

    );
};

export default inject('store')(observer(IncomePercentPage));
